import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

import Icon from 'components/atoms/Icon';

const useStyles = makeStyles((theme) => ({
  MbButton: {
    fontSize: 14,
    lineHeight: '14px',
    padding: `9px 14px`,
    minWidth: `auto`,
    height: '100%',
    textTransform: 'none',
  },
  basicButton: {
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      color: '#fff',
    },
  },
  filterButton: {
    backgroundColor: '#fff',
    border: '1px solid #e5e8eb',
    textTransform: 'none',
    color: '#000',
    '&:hover': {
      color: '#fff',
      backgroundColor: theme.palette.primary.main,
    },
    cursor: 'pointer',
  },
  upLoad: {
    backgroundColor: '#e0e0e0',
    textTransform: 'none',
    '&:hover': {
      color: '#fff',
      backgroundColor: theme.palette.primary.main,
    },
  },
  contained: (props) => {
    const { color = theme.palette.primary.main, textColor = '#fff' } = props;
    return {
      backgroundColor: color,
      color: textColor,
      '&:hover': {
        backgroundColor: color,
        opacity: 0.7,
      },
    };
  },
  iconBtn: {
    minWidth: '28px',
    height: '28px',
    padding: '2px',
    boxSizing: 'border-box',
    backgroundColor: 'rgba(0, 0, 0, 0.08)',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.15)',
    },
  },
  input: {
    display: 'none',
  },
}));

export default function MbButton(props) {
  const {
    color,
    textColor,
    children,
    basicButton,
    filterButton,
    iconBtn,
    upLoad,
    icon,
    clickEvent = (f) => f,
    changeEvent = (f) => f,
    ...rest
  } = props;
  const classes = useStyles({ color, textColor });
  return (
    <>
      {basicButton ? (
        <Button
          variant="contained"
          onClick={clickEvent}
          classes={{ root: classes.MbButton, contained: classes.contained }}
          {...rest}
        >
          {children}
        </Button>
      ) : filterButton ? (
        <Button
          onClick={clickEvent}
          classes={{ root: classes.filterButton }}
          {...rest}
        >
          {children}
        </Button>
      ) : upLoad ? (
        <>
          <input
            className={classes.input}
            id="buttonFile"
            multiple
            type="file"
            onChange={changeEvent}
          />
          <label htmlFor="buttonFile">
            <Button
              variant="contained"
              color="primary"
              component="span"
              classes={{ root: classes.upLoad }}
            >
              {children}
            </Button>
          </label>
        </>
      ) : iconBtn ? (
        <Button classes={{ root: classes.iconBtn }} {...rest}>
          {typeof icon !== undefined && (
            <Icon
              icon={icon}
              color={typeof color === 'undefined' ? '#8d9ba2' : color}
            />
          )}
          {children}
        </Button>
      ) : (
        <Button
          variant="contained"
          onClick={clickEvent}
          classes={{ root: classes.basicButton }}
          {...rest}
        >
          {children}
        </Button>
      )}
    </>
  );
}
